export default "__VITE_ASSET__C6ei10jh__"